import React from 'react'
import { Helmet } from 'react-helmet'

import { About, Github, Blog, Contacts, Education, Experience, Landing, Navbar, Projects, Skills } from '../../components'
import Circular from '../../components/Circular/Circular'
// import {} from '../../components/Github/Github'
// import { Github } from '../../components/Github/Github'
// import { Github } from '../../components/Github/Github'
import { headerData } from '../../data/headerData'
// import { Skills } from '../Skills/Skills'
// import GitHubCalendar from 'react-github-calendar';
// import Github from "./"

function HomePage() {
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - Porfolio</title>
            </Helmet>

            <Navbar />
            <Landing />
            <About />
            <Education />
            <Skills />
            {/* <Experience /> */}
            <Circular />
            {/* <Github /> */}
            <Github />
            {/* <GitHubCalendar username="kalashthakur" /> */}
            <Projects />
            {/* <Blog /> */}
            <Contacts />
        </div>
    )
}

export default HomePage
